import Body from 'commons/card/Body';
import { default as Card } from 'commons/card/CollapsableCard';
import Header from 'commons/card/Header';
import LoadingCard from 'commons/card/LoadingCard';
import React from 'react';
import { useParams } from 'react-router-dom';
import AddMedias from './AddMedias';
import ProjectDetail from './ProjectDetail';
import { useGetProjectQuery } from '../../../redux/api/cache';

export default function ProjectInfo() {
  const { Projet } = useParams();
  const { data: project, isLoading } = useGetProjectQuery({ seq: Projet });

  return (
    <div>
      {!isLoading && project?.data?.length === 0 && (
        <Card key={Math.random() + 'card'} type="error">
          <Header title={'Oups'}></Header>
          {!isLoading && (
            <Body>
              <label>{`Il n'y a aucun projet associé à cet identifiant`}</label>
            </Body>
          )}
        </Card>
      )}

      {!isLoading && project?.data && project?.data?.length !== 0 && (
        <ProjectDetail data={project.data[0]} />
      )}
      {!isLoading && project?.data && project?.data?.length !== 0 && (
        <AddMedias data={project.data[0]} />
      )}
      {isLoading && <LoadingCard title="Projet" />}
    </div>
  );
}
